import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { ModalShellComponent, ModalShellConfig } from '@shared/components/modal-shell/modal-shell.component';

export interface AppointmentAreaDialogData {
  currentAreas: string[];
  newAreas: string[];
}

@Component({
  selector: 'app-appointment-area-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatButtonModule, MatRadioModule, ModalShellComponent],
  template: `
    <app-modal-shell [config]="modalConfig">
      <div modal-content class="area-choice">
        <p>El ministerio tiene actividad en <strong>{{ data.currentAreas.join(', ') }}</strong>.
          El encargo o nombramiento se ejercerá en <strong>{{ data.newAreas.join(', ') }}</strong>.</p>
        <p id="area-choice-description">¿Qué querés hacer con la actividad en las áreas actuales?</p>
        <mat-radio-group [formControl]="keepCurrentAreas" aria-labelledby="area-choice-description">
          <mat-radio-button [value]="true">
            <strong>Mantener la actividad actual</strong>
            <span>El ministerio conservará las áreas actuales y sumará las nuevas. Si hay varias comunidades, elegirás una de pertenencia.</span>
          </mat-radio-button>
          <mat-radio-button [value]="false">
            <strong>Finalizar la actividad actual</strong>
            <span>El ministerio quedará en las nuevas áreas. También finalizarán los encargos y nombramientos de las áreas que se dejan. Si queda una sola comunidad, se generará el pase automáticamente.</span>
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <ng-container modal-actions>
        <button mat-button type="button" (click)="close(null)">Volver al formulario</button>
        <button mat-flat-button type="button" color="primary" [disabled]="keepCurrentAreas.value === null" (click)="close(keepCurrentAreas.value)">Continuar</button>
      </ng-container>
    </app-modal-shell>
  `,
  styles: [`
    .area-choice { color: #244560; font-size: 14px; line-height: 1.5; }
    mat-radio-group { display: grid; gap: 16px; margin-top: 20px; }
    mat-radio-button strong, mat-radio-button span { display: block; }
    mat-radio-button strong { font-weight: 500; }
    mat-radio-button span { margin-top: 4px; color: #687c8e; font-size: 13px; }
  `],
})
export class AppointmentAreaDialogComponent {
  readonly modalConfig: ModalShellConfig = { title: 'Actividad del ministerio', size: 'md', layout: 'form' };
  readonly keepCurrentAreas = new FormControl<boolean | null>(null);

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: AppointmentAreaDialogData,
    private readonly dialogRef: MatDialogRef<AppointmentAreaDialogComponent, boolean | null>,
  ) {}

  close(value: boolean | null): void { this.dialogRef.close(value); }
}
